import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, ReplaySubject, of } from 'rxjs';

import { CookieName } from '../browser/cookie/cookie.models';
import { CookieService } from '../browser/cookie/cookie.service';
import { FetchApiService } from '../browser/fetch-api.service';
import { Page } from '../client-config/page.client-config';
import { RememberMeConfig } from './remember-me.client-config';

/**
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class RememberMeService {
    retryNotifier: ReplaySubject<HttpErrorResponse | null> | null = null;

    private readonly rememberMeConfig = inject(RememberMeConfig);
    private readonly cookieService = inject(CookieService);
    private readonly page = inject(Page);
    private readonly fetchApiService = inject(FetchApiService);

    private get url(): string {
        return `${this.rememberMeConfig.apiHost.replace(/\/+$/, '')}/api/auth/rememberme?culture=${this.page.lang}`;
    }

    tokenExists(): boolean {
        return this.rememberMeConfig.isEnabled ? this.indicatorTokenExists() : false;
    }

    indicatorTokenExists(): boolean {
        return !!this.cookieService.get(CookieName.RmI);
    }

    authTokenExists(): boolean {
        return !!this.cookieService.get(CookieName.VnAuth);
    }

    setupTokenAfterLogin(): Observable<void> {
        if (!this.rememberMeConfig.isEnabled) {
            return of();
        }

        return this.fetchApiService.request({ url: this.url, method: 'PUT' });
    }

    login(data: any): Observable<any> {
        return this.fetchApiService.request({ url: this.url, method: 'POST', data });
    }

    logout(): Observable<void> {
        return this.fetchApiService.request({ url: this.url, method: 'DELETE' });
    }

    documentRequestLoginEnabled(): boolean {
        return this.rememberMeConfig.loginOnDocumentRequest;
    }
}
